// extracted by mini-css-extract-plugin
module.exports = {"root":"PasswordResetForm_root__2LnEi","password":"PasswordResetForm_password__uty2J"};